/**
 * ReportModal - Modal para geração de relatórios
 */
import React from 'react';
import { X, FileText, Printer, Mail, Image } from 'lucide-react';

interface ReportModalProps {
  closeReportModal: () => void;
  handleReportGeneration: (type: string) => void;
}

export const ReportModal: React.FC<ReportModalProps> = ({
  closeReportModal,
  handleReportGeneration,
}) => {
  const reportTypes = [
    {
      id: 'pdf',
      icon: FileText,
      label: 'PDF',
      description: 'Gerar relatório em PDF',
      color: 'from-red-500 to-rose-600',
    },
    {
      id: 'print',
      icon: Printer,
      label: 'Imprimir',
      description: 'Enviar para impressora',
      color: 'from-gray-600 to-gray-700',
    },
    {
      id: 'email',
      icon: Mail,
      label: 'E-mail',
      description: 'Enviar por e-mail',
      color: 'from-blue-500 to-indigo-600',
    },
    {
      id: 'image',
      icon: Image,
      label: 'Imagem',
      description: 'Exportar como imagem',
      color: 'from-purple-500 to-violet-600',
    },
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-500 to-teal-500 px-6 py-4 rounded-t-xl flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <FileText className="text-white" size={24} />
            <h3 className="text-lg font-semibold text-white">
              Gerar Relatório
            </h3>
          </div>
          <button
            onClick={closeReportModal}
            className="text-white hover:bg-white/20 rounded-lg p-1 transition"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Selecione o formato do relatório:
          </p>

          <div className="grid grid-cols-2 gap-3">
            {reportTypes.map((report) => {
              const Icon = report.icon;
              return (
                <button
                  key={report.id}
                  onClick={() => handleReportGeneration(report.id)}
                  className={`flex flex-col items-center p-4 rounded-lg bg-gradient-to-r ${report.color} text-white hover:opacity-90 transition shadow-md`}
                >
                  <Icon size={28} className="mb-2" />
                  <span className="font-semibold text-sm">{report.label}</span>
                  <span className="text-xs opacity-80 mt-1 text-center">
                    {report.description}
                  </span>
                </button>
              );
            })}
          </div>

          {/* Footer */}
          <div className="mt-6 flex justify-end">
            <button
              onClick={closeReportModal}
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg transition"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
